import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";
import { useQuery } from "react-query";

const fetchShifts = async () => {
  const { data } = await API.get("/shifts");
  return data;
};

const useGetShifts = () => {
  return useQuery([QUERY_KEY.GET_SHIFTS], fetchShifts);
};

export default useGetShifts;
